import React from "react";

const Spacer = (props: { double?: boolean }) => {
  return <div style={{ margin: props.double ? "32px" :"16px" }}> </div>;
};

export default Spacer;
